import AuthLayout from '../../components/Layout/AuthLayout';
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Button, MenuItem, TextField } from '@material-ui/core';
import chatApi from '../../api/chatApi';
import { getRegOrganisation, setRegOrganization } from '../../api/chatApi/chatApi';
import { ToastNotification } from '@carbon/react';
import { useStyles } from '../../components/auth/Forms/_Styles';

export default function AuthApproved() {
  const history = useHistory()
  interface organisationInterface {
    id: string
    name: string
  }
  const classes = useStyles()
  const [allOrganisations, setAllOrganisations] = useState([{id: 1, name: 'default'}])
  const [selectOrganisation, setSelectOrganisation] = useState<organisationInterface>(null)
  const [stateSuccess, setStateSuccess] = useState(false)
  const [isError, setIsError] = useState(false)
  const [isLoginError, setIsLoginError] = useState(false)
  const [name, setName] = useState('')
  const [secondName, setSecondName] = useState('')
  const [patronymic, setPatronymic] = useState('')
  const [login, setLogin] = useState('')

  function changeIsError() {
    setIsError(!isError)
    setTimeout(() => setIsError(false), 5000)
  }

  function changeStateSuccess() {
    setStateSuccess(!stateSuccess)
    setTimeout(() => setStateSuccess(false), 5000)
  }

  function checkLogin() {
    const loginRegExp = /^[a-z]+([-_]?[a-z0-9]+){0,2}$/i
    setIsLoginError(!loginRegExp.test(login))
  }

  useEffect(() => {
    getAllOrganisationHandler()
  }, [])

  async function approveAccountHandler() {
    try {
      await chatApi.activateAccount(history.location.search)
      await setRegOrganization({
        organization_id: selectOrganisation?.id,
        reset_key: history.location.search.split('=')[1],
        patronymic: patronymic.length > 0 ? patronymic.trim() : null,
        name: name.trim(),
        family: secondName.trim(),
        login: login.trim()
      })
      changeStateSuccess()
      setTimeout(() => history.replace('/login'), 2000)
    } catch (err) {
      changeIsError()
      console.log('при активации аккаунта произошла ошибка', err)
    }
  }

  async function getAllOrganisationHandler() {
    try {
      const response = await getRegOrganisation()
      if(response) {
        setAllOrganisations(response.data.RegOrganization)
      }
    } catch (err) {
      console.log('при получении всех организаций произошла ошибка', err)
    }
  }

  function selectOrganisationHandler(organisation: any) {
    console.log(organisation);
    setSelectOrganisation(organisation)
  }

  return (
    <AuthLayout>
      {
        stateSuccess &&
        <div style={{ position: 'fixed', top: 100, right: 0, zIndex: 1000 }}>
          <ToastNotification
            kind="success"
            hideCloseButton={false}
            lowContrast={false}
            iconDescription=""
            subtitle={
              <span></span>
            }
            timeout={0}
            title="Аккаунт успешно активирован"
          />
        </div>
      }
      {
        isError &&
        <div style={{ position: 'fixed', top: 100, right: 0, zIndex: 1000 }}>
          <ToastNotification
            kind="error"
            hideCloseButton={false}
            lowContrast={false}
            iconDescription="При обновлении данных произошла ошибка"
            subtitle={
              <span>{'Произошла ошибка, попробуйте позже'}</span>
            }
            timeout={0}
            title="Ошибка"
          />
        </div>
      }
      {
        isLoginError &&
        <div style={{ position: 'fixed', top: 100, right: 0, zIndex: 1000 }}>
          <ToastNotification
            kind="error"
            hideCloseButton={false}
            lowContrast={false}
            iconDescription="При обновлении данных произошла ошибка"
            subtitle={
              <span>Логин может содержать только латинские буквы, цифры, знаки "-" и "_" </span>
            }
            timeout={0}
            title="Ошибка"
          />
        </div>
      }
      <div style={{height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
        <span>
          Для завершения активации выберите организацию.
          После завершения регистрации вы сможете авторизоваться в программе
        </span>
      </div>
      <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', gap: 10, margin: '0 auto'}}>
        <TextField
          value={secondName}
          onChange={e => setSecondName(e.target.value)}
          required
          type='text'
          label='Фамилия'
          className={classes.input}
          autoComplete={'new-password'}
          fullWidth
        />
        <TextField
          value={name}
          onChange={e => setName(e.target.value)}
          type='text'
          required
          label='Имя'
          className={classes.input}
          autoComplete={'new-password'}
          fullWidth
        />
        <TextField
          value={patronymic}
          onChange={e => setPatronymic(e.target.value)}
          type='text'
          label='Отчество'
          className={classes.input}
          autoComplete={'new-password'}
          fullWidth
        />
        <TextField
          value={login}
          onChange={e => setLogin(e.target.value)}
          type='text'
          label='Логин'
          onBlur={checkLogin}
          className={classes.input}
          autoComplete={'new-password'}
          fullWidth
        />
        <TextField
          style={{ width: 550, margin: '30px auto' }}
          select
          variant={'outlined'}
          required
          size="small"
          label={'Выберите орагнизацию'}
          SelectProps={{
            MenuProps: {
              getContentAnchorEl: null,
              anchorOrigin: {
                vertical: 'bottom',
                horizontal: 'left',
              },
              transformOrigin: {
                vertical: 'top',
                horizontal: 'left',
              }
            }
          }}
        >
          {allOrganisations && allOrganisations?.map(organisation => (
            <MenuItem
              onClick={() => selectOrganisationHandler(organisation)}
              value={organisation?.name || ''}
              style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}
            >
              {organisation?.name || ''}
            </MenuItem>
          ))}
        </TextField>
        <Button
          variant='contained'
          size={'medium'}
          color={'primary'}
          disabled={selectOrganisation === null || secondName.length === 0 || name.length === 0}
          onClick={approveAccountHandler}>Сохранить</Button>
      </div>
    </AuthLayout>
  )
}
